import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/driver/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/driver/detail/v2', Object.assign({}, options, {
    params
  }));

export const beforeDelete = (params, options) =>
  request.post('/api/park/region/beforeDelete/v2', qs.stringify(params), options);

export const remove = (params, options) =>
  request.post('/api/park/driver/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/driver/save/v2', params, options);

export const update = (params, options) => request.post('/api/park/driver/update/v2', params, options);

export const driverSelections = (params, options) =>
  request.post('/api/park/driver/selections/v2', qs.stringify(params), options);

export const syncDrivers = (params, options) =>
  request.post('/api/park/driver/sync/v2', qs.stringify(params), options);

export const getSpaceList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/parkSpaceList/v2', Object.assign({}, options, {
    params
  }));

export const removeCar = (params, options) =>
  request.post('/api/park/vehicle/car/remove/v2', params, options);
